import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'

export const usePasswordValidationSchema = () => {
	const { t } = useTranslation()

	const passwordValidationSchema = yup.object({
		password: yup.string().required(t('Password is required')),
		password2: yup.string().oneOf([yup.ref('password'), undefined], t('Passwords must match'))
	})

	return yupResolver(passwordValidationSchema)
}
